import { forOwn, get } from 'lodash'

/* eslint @typescript-eslint/no-use-before-define: 0 */

const transformItemFields = fields => {
  // If fields does not exist, we do nothing
  // Otherwise we will be setting it to {}
  if (!fields) {
    return fields
  }
  const transformedFields = {}
  forOwn(fields, (value, key) => {
    transformedFields[key] = Array.isArray(value)
      ? value.map(item => transformItem(item))
      : transformItem(value)
  })
  return transformedFields
}

const transformItem = item =>
  item && item.sys
    ? {
        fields: transformItemFields(item.fields),
        sys: {
          id: item.sys.id,
          contentType: get(item, 'sys.contentType.sys.id', 'asset'),
        },
      }
    : item

export const transform = data =>
  // Data from contentful comes in the form { fields, sys }
  // We want to clean up the { sys } portion
  ({
    items: get(data, 'items', []).map(transformItem),
    assets: get(data, 'includes.Asset', []).map(transformItem),
    entries: get(data, 'includes.Entry', []).map(transformItem),
  })

const populateEntryField = (entriesAndAssets, entryField) => {
  // This will fetch the populated item from the entries and assets store if possible.
  if (entryField.sys && !entryField.fields) {
    const entry = entriesAndAssets[entryField.sys.id]
    // Populate the children
    return populateEntry(entriesAndAssets, entry)
  }
  return entryField
}

const populateEntry = (entriesAndAssets, entry) => {
  const entryFields = {}
  // For each field...
  forOwn(entry && entry.fields, (value, key) => {
    if (Array.isArray(value)) {
      // If it is an array, we try populated everything in the array
      entryFields[key] = value.map(item => populateEntryField(entriesAndAssets, item))
    } else {
      // Otherwise we populate as usual
      entryFields[key] = populateEntryField(entriesAndAssets, value)
    }
  })

  return {
    ...entry,
    fields: {
      ...entryFields,
    },
  }
}

export const populate = (entriesAndAssets, entries) =>
  entries.map(entry => populateEntry(entriesAndAssets, entry))



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Cms.utils.js